import type { Filter, FilteredFilter } from '@core/Entities/Search/SearchFilters/Filter.entity';

const FILTERS_TO_RESET = ['page'];

const applyFilterChanges = (
  existingFilters: Filter[],
  changes: Filter[],
): FilteredFilter[] | null => {
  const updatedFilters = existingFilters.map(existingFilter => {
    const change = changes.find(change => change.id === existingFilter.id);
    if (Array.isArray(change?.value)) {
      return { id: existingFilter.id, value: change?.value };
    }

    if (change && change.value !== existingFilter.value) {
      return { id: existingFilter.id, value: change.value };
    }
    return existingFilter;
  });

  const newFilters = changes.filter(
    change => !existingFilters.some(filter => filter.id === change.id),
  );

  if (
    newFilters.length === 0 &&
    updatedFilters.every(filter =>
      existingFilters.some(f => f.id === filter.id && f.value === filter.value),
    )
  ) {
    return null;
  }

  const notUndefined = (filter: Filter): filter is FilteredFilter => {
    const { value } = filter;
    if (Array.isArray(value)) return value.length > 0;
    return value !== undefined;
  };

  // Certain filters need to be reset on every change (unless they are in the changes)
  const resetFilters = (filter: Filter): filter is FilteredFilter => {
    const { id } = filter;

    if (FILTERS_TO_RESET.includes(id) && !changes.some(filterChange => filterChange.id === id))
      return false;

    return true;
  };

  return updatedFilters.concat(newFilters).filter(notUndefined).filter(resetFilters);
};

export { applyFilterChanges };
